"use strict";

module.exports = function (config, get) {
	return {
		own: own_managegroup
	};

	function own_managegroup(){
		return get("/v2/managegroup/own");
	}
};